<template>
  <div class="row">
    <h4 class="section-title" v-if="!isMyEntityPage">
      <span>{{ $i18n.t('UserForm.other_entities') }}</span>
    </h4>
    <div class="col-md-12 m-t-20 m-b-20" v-if="isNewUser">
      <span class="message-new-tag">{{ $i18n.t('ManagerEntities.message_new_tag') }}</span>
    </div>

    <div class="row manager-entities-list">
      <div class="card" v-for="managerEntity in managerEntities" :class="tagClass(managerEntity)">
        <div class="card-header">
          <div class="row">
            <div class="col p-10 h6">
              <div><b>{{  managerEntity.entity.name }}</b></div>
              <div>{{ managerEntity.function }}</div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md mb-3 mb-md-0">
              <div class="description">Service(s): </div>
              <services-grouped-by-hubs :services="managerEntity.services"
                                        :shortened="true"
                                        :hubs="hubs(managerEntity)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ie_mixin from '@/mixin/ie'
  import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

  export default {
    name: "ManagerEntitiesTable",
    mixins: [ie_mixin],
    components: {
      ServicesGroupedByHubs
    },
    data: function(){
      return {
        isNewUser: false
      }
    },
    props: ['managerEntities', 'isMyEntityPage', 'currentUser'],
    computed: {
      siblingEntities() {
        if (this.isMyEntityPage) {
          return this.managerEntities
        }
        return this.$store.state.users.siblingEntities
      },
      tableHeadings() {
        return [
          { 'key': 'entity', 'value': this.$i18n.t('UserForm.establishment') },
          { 'key': 'services', 'value': this.$i18n.t('table.headers.services') }
        ]
      }
    },
    methods: {
      hubs(managerEntity) {
        if(!managerEntity || !managerEntity.entity) {
          return []
        }

        return managerEntity.entity.hubs
      },
      entityName(managerEntity) {
        if (this.isMyEntityPage) {
          return this.siblingEntities.find(item => item.entity.id == managerEntity.entity.id).entity.name
        }
        return this.siblingEntities.find(entity => entity.id == managerEntity.entity_id).name
      },
      servicesName(managerEntity) {
        return managerEntity.services.map(service => service.name).join(' / ')
      },
      tagClass(managerEntity) {
        if (this.isMyEntityPage && managerEntity.is_new_created) {
          this.isNewUser = true
          return 'new-user'
        }
      }
    }
  }
</script>

<style scoped>
  h4.section-title {
    width: 100%;
    text-align: left;
    border-bottom: 2px solid #f1f1f1;
    line-height: 0.1em;
    margin: 10px 0 20px;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 14px;
  }

  .section-title span {
    background: #fff;
    padding: 0 10px;
    text-transform: uppercase;
  }

  .message-new-tag {
    color: #004085;
    background-color: #cce5ff;
    border-color: #b8daff;
    padding: 15px;
    border-radius: 5px;
  }
  .manager-entities-list {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/ManagerEntitiesTable.vue